// extracted by mini-css-extract-plugin
module.exports = {"activeCell":"ActiveBodyCell_activeCell__2Yd1-","bgShow":"ActiveBodyCell_bgShow__1IOpH"};